module.exports = {"450304001":"南门街道","450304002":"象山街道","450304003":"平山街道","450304200":"二塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450304.json
// module id = 2221
// module chunks = 0